import React, { useState, useEffect } from "react";
import classnames from "classnames";

// Components
import Icon from "../icon/Icon";
import ContactDetailsBox from "../contact-details-box/ContactDetailsBox";
import ContactUsChatBanner from "../contact-us-chat-banner/ContactUsChatBanner";

// Util
import { getSolutionContactDetails } from "../../utils/data/getContactDetails";

// Styles
import styles from "./contact-us-product-stock-other-solution.module.scss";

function ContactUsStandardSolution({
  solution: { id, title, fields, buttonType, hierarchyPosition },
  className,
  contactMethods = {},
}) {
  const [isBannerSupported, setIsBannerSupported] = useState(false);

  useEffect(() => {
    const getContactDetails = async () => {
      const contactDetails = await getSolutionContactDetails(
        `${hierarchyPosition[0]} | ${hierarchyPosition[1]} | ${hierarchyPosition[2]}`,
      );
      setIsBannerSupported(contactDetails.chat.partnersBanner);
    };

    getContactDetails();
  }, []);

  const locationOnPage = hierarchyPosition.join(" | ");

  return (
    <article className={classnames(styles.productStockSolution, className)} data-solution-id={id}>
      <h2 className={styles.productStockSolution__top}>Did you know...</h2>
      <div className={styles.productStockSolution__inner} data-test="solution-inner">
        {title && <h2 data-test="solution-name">{title}</h2>}
        <div className={styles.productStockSolution__content}>
          <div>
            <div className={styles.productStockSolution__paragraph}>
              <Icon name="headset" />
              <p>
                Unfortunately, <b>our customer service team won’t be able to give you an exact date</b> that an item
                will be back in stock.
              </p>
            </div>
            <div className={styles.productStockSolution__paragraph}>
              <Icon name="email" />
              <p>
                If you’ve found an item that you like,{" "}
                <b>we can send you an email notification as soon as it’s back in stock.</b> Simply visit the product
                page and enter your email address in the ‘Notify me’ section. If the item is a particular size, colour
                or design, you’ll need to select this before entering your email address.
              </p>
            </div>
          </div>
        </div>
        {isBannerSupported && (
          <ContactUsChatBanner
            location={locationOnPage}
            channel={fields.find(({ name }) => ["chat"].includes(name)).content}
          />
        )}
        <ContactDetailsBox
          fields={fields.filter(({ name }) => ["phone", "chat", "email"].includes(name))}
          buttonType={buttonType}
          solutionId={id}
          className={styles["productStockSolution__contact-details"]}
          location={locationOnPage}
          contactMethods={contactMethods}
          title={"We’re here to help"}
          viewContactDetails
          showGreyBackground
        />
      </div>
    </article>
  );
}

export default ContactUsStandardSolution;
